import { classNames } from 'libs/react';
import { FormFieldTooltip } from './FormFieldTooltip';
import { React } from 'libs/react';
import { Icon } from 'components/Icon';
import './FormFieldLabel.scss';
/**
 * @component FormFieldLabel
 * @since 1.0.0
 */
export function FormFieldLabel(props) {
    const { size, style, label, ident, tooltip, required, optional, disabled } = Object.assign({ size: 'medium', style: 'normal' }, props);
    if (label == null || label == '') {
        return null;
    }
    const className = classNames('form-field-label', 'form-field-label--' + size, 'form-field-label--' + style, { 'form-field-label--is-required': required }, { 'form-field-label--is-optional': optional }, { 'form-field-label--is-disabled': disabled }, props.className);
    return (React.createElement("label", { className: className, htmlFor: ident },
        React.createElement("div", { className: "form-field-label-text" },
            label,
            required && (React.createElement(Icon, { value: "fas circle", className: "form-field-label-picto" }))),
        tooltip && (React.createElement("span", { className: "form-field-label-more" },
            React.createElement(FormFieldTooltip, { title: tooltip })))));
}
